import AssociationProxy from './association_proxy'

export default class AssociationInjector
  constructor: (@entitySpace, @associations, @collectionConstructor) ->

  @for: (entitySpace, associations, collectionConstructor) ->
    new @(entitySpace, associations, collectionConstructor)

  withSpace: (entitySpace) ->
    new @constructor(entitySpace, @associations, @collectionConstructor)

  inject: (entity) =>
    unless entity.associations?.associationInjector == @
      entity.associations = new AssociationProxy(entity, @)

    entity
